module.exports = __webpack_public_path__ + "static/img/book40.67bbc30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book40.jpg
// module id = me2V
// module chunks = 1